export function humanFileSize(bytes: number, si: boolean) {
    if(bytes==null) {
        return "0 B";
    }

    let thresh = si ? 1000 : 1024;
    if(Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }
    let units = si
        ? ['kB','MB','GB','TB','PB','EB','ZB','YB']
        : ['KiB','MiB','GiB','TiB','PiB','EiB','ZiB','YiB'];
    let u = -1;
    do {
        bytes /= thresh;
        ++u;
    } while(Math.abs(bytes) >= thresh && u < units.length - 1);
    return bytes.toFixed(1)+' '+units[u];
}

export function format_time_seconds(t: number, s: boolean)
{
    var x_min=60;
    var x_hour=x_min*60;
    var x_day=x_hour*24;
    var x_week=x_day*7;
    var x_month=x_week*4.345;
    var x_year=x_month*12;
    
    interface XTP {
        year: number,
        month: number,
        week: number,
        day: number,
        hour: number,
        min: number
    }

    let x_tp = [x_year, x_month, x_week, x_day, x_hour, x_min];
    let x_tp_name = ["year", "month", "week", "day", "hour", "min"];
    
    var neg=false;
    if(t<0)
    {
        neg=true;
        t*=-1;
    }

    let ret="";
    for(let i=0;i<x_tp.length;i+=1)
    {
        let x=x_tp_name[i];
        let y=Math.floor(t/x_tp[i]);
        if(y>0)
        {
            if(ret!=="")
                ret+=" ";
                
            if(neg)
                ret+="-";
                
            ret+=y;
            var c_s=(s===true);
            if(c_s)
            {
                if(x==="hour") ret+="h";
                else if(x==="min") ret+="m";
                else c_s=false;
            }
            
            if(!c_s)
            {
                ret+=" ";
                if(y>1)
                    ret+=x+"s";
                else
                    ret+=x;
            }
            
                
            t-=x_tp[i]*y;
        }
    }
    
    return ret;
}

export function calculateCost(size_gb: number): number {
    const costPerGbHour = 0.0000140625; 
    const baselineCostHour = 0.028; 
    return size_gb * costPerGbHour + baselineCostHour;
}

export function calculateCostPerMonth(size_gb: number): number {
    const hoursInMonth = 24 * 31; 
    return calculateCost(size_gb) * hoursInMonth;
}